<p-popover
  appPopoverArrow
  #panel
  appendTo="body"
  styleClass="ai-popover"
  (onShow)="onShow()"
  (onHide)="closeView.emit()"
>
  <div class="ai">
    <div class="ai__heading">Enter shipment parameters</div>

    <form [formGroup]="form">
      <textarea
        pInputText
        class="form-control"
        rows="10"
        formControlName="text"
        placeholder="Paste shipment parameters here"
      ></textarea>
    </form>

    <div class="ai__actions">
      <button
        pButton
        severity="primary"
        [outlined]="true"
        [disabled]="loading"
        (click)="panel.hide()"
      >
        <i class="pi pi-times"></i>
        Cancel
      </button>
      <button
        pButton
        severity="primary"
        [disabled]="loading || form.invalid || disabled()"
        (click)="extract()"
      >
        @if (loading) {
          <i class="pi pi-spinner pi-spin"></i>
        } @else {
          <i class="pi pi-check"></i>
        }
        Extract
      </button>
    </div>
  </div>
</p-popover>

<button
  pButton
  type="button"
  size="small"
  class="ai-btn p-button-ai"
  (click)="panel.toggle($event)"
>
  <i class="pi pi-sparkles" aria-hidden="true"></i>
</button>
